module.exports = __webpack_public_path__ + "img/42.e743fbbd.jpg";